import React from 'react';
import { Link } from 'react-router-dom';
import '../css/customer.css';

function Customer() {
  return (
    <div className="customer-content">
      <h2 className="page-title">Customer Management</h2>

      <div className="customer-card-container">
        <div className="customer-card">
          <h3>Customer</h3>
          <p>Manage customer information and profiles.</p>
          <Link to="/customer-list">Go to Customers</Link>
        </div>

        <div className="customer-card">
          <h3>Plan</h3>
          <p>Manage subscription plans and service details.</p>
          <Link to="">Go to Plans</Link>
        </div>
      </div>
    </div>
  );
}

export default Customer;
